<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 6814 6814"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <g id="_307892304">
   <path class="fil0"
         d="M5489 2907c82,94 157,105 239,179 230,206 378,642 272,1008 -125,427 -492,724 -1033,724l-3135 0c-578,0 -999,-381 -1057,-892 -34,-296 58,-551 210,-730 234,-277 251,-201 595,-379 -28,-1146 867,-1282 1329,-1039 274,-264 636,-563 1222,-425 536,126 689,444 881,843 383,24 580,330 477,711zm-5489 139l0 723c146,328 80,1130 999,2046 250,249 517,453 880,636 631,317 910,250 1167,363l722 0c337,-148 1121,-76 2047,-999 917,-914 848,-1698 999,-2046l0 -723c-71,-164 -89,-439 -147,-626 -177,-576 -455,-1016 -852,-1421 -498,-509 -1157,-834 -1865,-953l-131 -28c-8,-3 -19,-7 -26,-9 -7,-2 -18,-5 -27,-9l-718 0 -157 42c-53,9 -104,15 -156,25 -111,22 -217,50 -316,80 -1087,330 -1933,1170 -2272,2273 -57,187 -76,462 -147,626z" />
    <path class="fil1"
          d="M4617 3826c49,41 148,20 254,32l-5 148 -520 1c19,-296 419,-373 303,-600 -129,-17 -80,24 -157,50 -70,24 -86,-5 -144,-21 188,-322 444,-150 484,-55 83,199 -141,333 -215,445zm-1143 -1146c737,-228 1082,838 372,1077 -770,259 -1076,-860 -372,-1077zm-514 897c-171,188 -387,281 -660,182 -790,-286 -171,-1602 669,-919 -38,91 -51,121 -152,175 -124,-77 -206,-168 -396,-109 -419,128 -209,972 388,531 84,44 95,70 151,140zm2529 -670c103,-381 -94,-687 -477,-711 -192,-399 -345,-717 -881,-843 -586,-138 -948,161 -1222,425 -462,-243 -1357,-107 -1329,1039 -344,178 -361,102 -595,379 -152,179 -244,434 -210,730 58,511 479,892 1057,892l3135 0c541,0 908,-297 1033,-724 106,-366 -42,-802 -272,-1008 -82,-74 -157,-85 -239,-179z" />
    <path class="fil0"
          d="M3532 2893c433,-174 622,488 257,652 -417,185 -643,-497 -257,-652zm-58 -213c-704,217 -398,1336 372,1077 710,-239 365,-1305 -372,-1077z" />
    <path class="fil0"
          d="M2960 3577c-56,-70 -67,-96 -151,-140 -597,441 -807,-403 -388,-531 190,-59 272,32 396,109 101,-54 114,-84 152,-175 -840,-683 -1459,633 -669,919 273,99 489,6 660,-182z" />
    <path class="fil2" d="M3532 2893c-386,155 -160,837 257,652 365,-164 176,-826 -257,-652z" />
    <path class="fil0"
          d="M4866 4006l-8 -130 -278 -14 37 -36c74,-112 298,-246 215,-445 -40,-95 -296,-267 -484,55 58,16 74,45 144,21 77,-26 28,-67 157,-50 116,227 -284,304 -303,600l520 -1z" />
    <path class="fil3" d="M4866 4006l5 -148c-106,-12 -205,9 -254,-32l-37 36 278 14 8 130z" />
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'CO2Meter',
};
</script>

<style scoped>
.fil2 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}

.fil3 {
  fill: #8C96A0
}

.fil1 {
  fill: white
}
</style>
